import $ from 'jquery';

let playVideo = (vid) => {
  vid.play();
}
let $video = $('#background-video'),
    videoElement = $video[0];
if(videoElement) {
  videoElement.readyState >= videoElement.HAVE_FUTURE_DATA ? playVideo(videoElement)
    : () => { videoElement.addEventListener('canplay', () => {
        playVideo(videoElement);
      }, false) };
} else {}
